type ScheduleDay = {
  paused?: boolean
  times?: readonly unknown[]
}

export function countActiveSlots(
  schedule: readonly ScheduleDay[] | null | undefined,
): number {
  if (!schedule) return 0
  return schedule.reduce((count, day) => {
    if (!day.paused && day.times) return count + day.times.length
    return count
  }, 0)
}
